import React from 'react';

export default function MainHeadingSub({ simple, highlighted, imageSrc }) {
  return (
    <div
      className="Hero-bg"
      style={{
        backgroundImage: imageSrc,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="w-11/12 2xl:w-[1150px] mx-auto pt-[100px] md:pt-[375px] pb-[80px] md:pb-[100px] flex flex-col justify-between h-full">
        <div className="w-full lg:w-[837px] py-6 px-[35px] flex-grow flex items-end">
          <div className="content">
            <h1 className="title-heading">
              {simple}
              <span className="text-green">{highlighted}</span>
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}
